import type { category } from '@/types/category';

const PREFERRED_CATEGORY_ORDER = [1, 9, 8, 6];

export const sortCategoriesWithOrder = (categories: category[]): category[] => {
  if (!Array.isArray(categories)) {
    return [];
  }

  return [...categories].sort((a, b) => {
    const indexA = PREFERRED_CATEGORY_ORDER.indexOf(a.id);
    const indexB = PREFERRED_CATEGORY_ORDER.indexOf(b.id);

    // If both are in the preferred order, sort by their index in PREFERRED_CATEGORY_ORDER
    if (indexA !== -1 && indexB !== -1) {
      return indexA - indexB;
    }

    // If only A is in preferredOrder, A comes first
    if (indexA !== -1) {
      return -1;
    }

    // If only B is in preferredOrder, B comes first
    if (indexB !== -1) {
      return 1;
    }

    // If neither are in preferredOrder, sort them by ID (or name, or maintain original relative order)
    // Sorting by ID is a common fallback.
    return a.id - b.id;
  });
};
